module.exports = __webpack_public_path__ + "img/blender-phone.91ad5446.svg";